module.exports = "/work-site/img/spms.c444c9fa.png";